import { useDispatch } from 'react-redux';

import {
  getRequestsList,
  getCreationFrom,
  getSingleRequest,
  createRequest,
  updateRequest,
  deleteRequest,
  setFilter,
  clearState
} from 'actions/maintenanceRequestsActions';

export default function useTicketActions() {
  const dispatch = useDispatch();

  const getRequestsListAction = (q) => dispatch(getRequestsList(q));

  const setFilterAction = (data) => dispatch(setFilter(data));

  const getRequestAction = (q) => dispatch(getSingleRequest(q));

  const getCreationFromAction = (q) => dispatch(getCreationFrom(q));

  const createRequestAction = (data) => dispatch(createRequest(data));
  const updateRequestAction = (data) => dispatch(updateRequest(data));
  const deleteRequestAction = (id) => dispatch(deleteRequest(id));

  const clearStateAction = () => dispatch(clearState());

  return {
    getRequestsListAction,
    setFilterAction,
    getRequestAction,
    getCreationFromAction,
    createRequestAction,
    updateRequestAction,
    deleteRequestAction,
    clearStateAction
  };
}
